import { ListViewRequestTypes } from '../../../../../Enums';

export const getShiftCardClass = (requestType) => {
    switch (requestType) {
        case ListViewRequestTypes.myPaycode:
            return 'employeePaycodeCard';
        case ListViewRequestTypes.myShift:
            return 'employeeShiftCard';
        case ListViewRequestTypes.toCover:
            return 'TCShiftCard';
        case ListViewRequestTypes.shiftSwap:
            return 'SSShiftCard';
        case ListViewRequestTypes.openShift:
            return 'OSShiftCard';
        case ListViewRequestTypes.voluntaryTimeOff:
            return 'VTOShiftCard';
        default:
            return '';
    }
};